@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row && $.adata.fetch_key && $.adata.type === 'yes-no') {
    <span>{{
      $.row[$.adata.fetch_key] === 1 || $.row[$.adata.fetch_key] === '1'
        ? 'Yes'
        : 'No'
    }}</span>
  }
  @if ($.row && $.adata.fetch_key && $.adata.type === 'boolean') {
    <span>{{ $.row[$.adata.fetch_key] ? 'True' : 'False' }}</span>
  }
  @if ($.row && $.adata.fetch_key && $.adata.type === 'checkIn') {
    <span>{{
      $.row[$.adata.fetch_key] > 0 ? ' Checked-in' : 'Checked-out'
    }}</span>
  }
  @if ($.row && $.adata.fetch_key && $.adata.type === 'stringboolean') {
    <span>{{
      $.row[$.adata.fetch_key] &&
      $.row[$.adata.fetch_key].toLowerCase() === 'true'
        ? 'Yes'
        : 'No'
    }}</span>
  }
  @if ($.row && $.adata.fetch_key && $.adata.type === 'booleanyesno') {
    <span>{{ $.row[$.adata.fetch_key] === true ? 'Yes' : 'No' }}</span>
  }
  @if ($.row && $.adata.fetch_key && $.adata.type === 'booleanactiveinactive') {
    <span>{{
      $.row[$.adata.fetch_key] === 'True' ? 'Active' : 'Inactive'
    }}</span>
  }
}
